<!--项目进度报表-->
<template>
  <div class="app-container">
    <el-card class="box-card">
        <el-table
        :data="list"
        max-height="520px"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        :spanMethod="spanMethod"
        :border="true"
        >
        <el-table-column prop="projectName" label="项目名称"></el-table-column>
        <el-table-column prop="projectManager" label="项目经理" align="center"></el-table-column>
				<el-table-column prop="projectParticipant" label="项目参与人" align="center" ></el-table-column>
        <el-table-column prop="contractBalance" label="合同金额" align="center" ></el-table-column>
        <el-table-column label="项目进度" align="center">
            <el-table-column prop="projectMilestone" label="项目阶段" align="center" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fundDetails" label="收款明细" align="center"></el-table-column>
            <el-table-column prop="planTime" label="计划完成时间" align="center" :formatter="formatter"></el-table-column>
            <el-table-column prop="actualTime" label="实际完成时间" align="center"></el-table-column>
        </el-table-column>
        <el-table-column prop="receiptBalance" label="收款金额" align="center" ></el-table-column>
        <el-table-column prop="balance" label="余额" align="center" ></el-table-column>
        <el-table-column prop="actualCost" label="实际交付成本" align="center" ></el-table-column>
        <el-table-column prop="grossProfit" label="毛利" align="center" ></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import { getProjectList} from "@/api/reports";
import { parseTime } from "@/utils";

export default {
  name: "ProjectProgress",
  data() {
    return {
      list: [],
      spanArr: [],
      position: 0,
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.getList()
  })
  },
  watch: {
      list: {
          handler(val) {
              this.rowspan(0,"projectName")
              this.rowspan(1,"projectManager")
              this.rowspan(2,"projectParticipant")
              this.rowspan(3,"contractBalance")
              this.rowspan(10,"actualCost")
              this.rowspan(11,"actualCost")
              },
          deep: true
          }
  },
  methods: {
      formatter(val,column) {
      if (column) {
        const date = new Date(val.planTime);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    // 获取列表数据
    getList() {
      getProjectList().then(res => {
        const arr = []
        res.data.records.forEach((el,index) => {
          el.projectName = el.project ? el.project.name : ''
          el.projectManager = el.projectManager.name;
          arr.push(el)
        })
        this.list =  arr
      })
    },
    /**
     * 单元格合并
     */
    spanMethod({ row, column, rowIndex, columnIndex }) {
      for (let i = 0; i < 4; i++) {
        if (columnIndex === i) {
          const _row = this.spanArr[i][rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
      }
      if (columnIndex === 10) {
          const _row = this.spanArr[10][rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
      }
       if (columnIndex === 11) {
          const _row = this.spanArr[11][rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
      }
	},
	rowspan(idx, prop) {
      this.spanArr[idx] = [];
      this.position = 0;
      this.list.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1);
          this.position = 0;
        } else {
          if (this.list[index][prop] === this.list[index - 1][prop] && this.as(idx,prop,index)) {
            this.spanArr[idx][this.position] += 1; // 有相同项
            this.spanArr[idx].push(0); // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1); // 同列的前后两行单元格不相同
            this.position = index;
          }
        }
      });
	},
	as(idx,prop,index) {
		if (idx === 0) return true
		if (idx === 1 && this.list[index]["projectName"] === this.list[index - 1]["projectName"]) {
			return true
		} else if (idx === 2 && this.list[index]["projectName"] === this.list[index - 1]["projectName"]) {
			return true
		} else if (idx === 3 && this.list[index]["projectName"] === this.list[index - 1]["projectName"]) {
			return true
    } else if (idx === 10 && this.list[index]["projectName"] === this.list[index - 1]["projectName"]) {
			return true
		} else if (idx === 11 && this.list[index]["projectName"] === this.list[index - 1]["projectName"]) {
			return true
		} else {
			return false
		}
	}
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-table--border td {
  border-right: 1px solid #dfe6ec !important;
}
/deep/ .el-table__header-wrapper thead{
      color: #606266;
    font-weight: 600;
    // background-color: #FBFBFB;
}
/deep/ .el-table__header-wrapper thead tr > th{
   background-color: #FBFBFB;
}
</style>
